import React, { useState, useEffect, useRef } from 'react'

const SmartLazyImage = ({
  src,
  alt = 'image',
  orientation = 'landscape',
  placeholderPortrait,
  placeholderLandscape,
  onClick,
  className = '',
  style = {},
  imgClassName = '',
  imgStyle = {},
  eager = false,
  rootMargin = '600px'
}) => {
  const [isVisible, setIsVisible] = useState(eager)
  const [isLoaded, setIsLoaded] = useState(false)
  const [hasError, setHasError] = useState(false)

  const imageRef = useRef(null)

  const placeholder =
    orientation === 'portrait' ? placeholderPortrait : placeholderLandscape

  useEffect(() => {
    if (eager) {
      setIsVisible(true)
      return
    }

    const target = imageRef.current
    if (!target) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin }
    )

    observer.observe(target)

    return () => observer.disconnect()
  }, [eager, rootMargin])

  const displaySrc =
    hasError || !src ? placeholder : isLoaded ? src : placeholder

  // return (
  //   <div className={className} style={{ ...style }} onClick={onClick}>
  //     <img
  //       ref={imageRef}
  //       src={isVisible ? displaySrc : placeholder}
  //       alt={alt}
  //       loading={eager ? 'eager' : 'lazy'}
  //       className={imgClassName}
  //       style={{
  //         cursor: onClick ? 'pointer' : 'default',
  //         width: '100%',
  //         height: 'auto',
  //         objectFit: 'cover',
  //         transition: 'opacity 0.4s ease-in-out',
  //         opacity: isLoaded ? 1 : 0.7,
  //         maxWidth: '720px',
  //         background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 100%)',
  //         ...imgStyle
  //       }}
  //       onLoad={() => setIsLoaded(true)}
  //       onError={() => {
  //         setHasError(true)
  //         setIsLoaded(false)
  //       }}
  //     />
  //   </div>
  // )
  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={style}
      onClick={onClick}
    >
      <img
        ref={imageRef}
        src={isVisible ? displaySrc : placeholder}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        className={imgClassName}
        style={{
          cursor: onClick ? 'pointer' : 'default',
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
          transition: 'opacity 0.4s ease-in-out',
          opacity: isLoaded ? 1 : 0.7,
          maxWidth: '720px',
          ...imgStyle
        }}
        onLoad={() => setIsLoaded(true)}
        onError={() => {
          setHasError(true)
          setIsLoaded(false)
        }}
      />

      {/* Gradient Overlay */}
      {/* Gradient overlay disabled: it darkened the baked-in AI watermark on the Discover feed.
      To restore, uncomment (or add a showGradient prop); consider a lighter fade or a title textShadow.
      {/* <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 60%, #000000 100%'
        }}
      /> */}
    </div>
  )
}

export default React.memo(SmartLazyImage)
